import { render, staticRenderFns } from "./search.vue?vue&type=template&id=1cefbf5c&shadow"
import script from "./search.vue?vue&type=script&lang=js&shadow"
export * from "./search.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports